module.exports = __webpack_public_path__ + "img/premium.d04809b1.svg";